import { InteractiveTutorial, InteractiveTutorialProps } from "@/features/interactive_tutorial";
import { Image, TourStepProps } from "antd";
const steps: TourStepProps[] = [{
  title: "Scenario",
  description: <>
        <p>
          Filter the data in the dashboard by selecting the desired emission scenario from the <b>Scenario</b> drop
          down. You may select a single RCP or many. To save the selection, click <b>Update Filter</b>.
        </p>
        <Image alt="Highlight the Scenario dropdown." src="/_/img/tours/physical_risk_table/step_2.jpg" />
      </>
}, {
  title: "Hazards",
  description: <>
        <p>
          To view data for a specific hazard, select an option from the <b>Specific Hazard or All Hazards</b> drop down.
          You may select a single hazard or many. To save the selection, click <b>Update Filter</b>.
        </p>
        <Image alt="Highlight the Hazard dropdown." src="/_/img/tours/physical_risk_table/step_3.jpg" />
      </>
}, {
  title: "TPU",
  description: <>
        <p>
          To view data for specific TPUs, select the ID from the <b>TPU ID</b> drop down. You may select a single TPU or
          many. To save the selection, click <b>Update Filter</b>.
        </p>
        <Image alt="Highlight the TPU dropdown." src="/_/img/tours/physical_risk_table/step_4.jpg" />
      </>
}, {
  title: "Point Count",
  description: <>
        <p>To reorder the data within a table in ascending or descending order, click the desired column header.</p>
        <Image alt="Highlight the Point Count sort button." src="/_/img/tours/physical_risk_table/step_5.jpg" />
      </>
}, {
  title: "Download Results",
  description: <>
        <p>
          To download the results from an individual table, click on the <b>...</b> at the top right hand side of each
          data table, and select <b>Download Results</b>. Then select the desired file type (.csv, .xlsx, or .json).
        </p>
        <Image alt="Highlight the Download Results button." src="/_/img/tours/physical_risk_table/step_6.jpg" />
      </>
}, {
  title: "Export as PDF",
  description: <>
        <p>
          To download a snapshot of the entire dashboard, with all current filters applied, select <b>Export as PDF</b>{" "}
          from the top right of the dashboard.
        </p>
        <Image alt="Highlight the Export as PDF button." src="/_/img/tours/physical_risk_table/step_7.jpg" />
      </>
}];
export const TpuTutorial = (props: InteractiveTutorialProps<Record<any, any>>) => {
  return <InteractiveTutorial<Record<any, any>> isWide={true} steps={steps} {...props} data-sentry-element="InteractiveTutorial" data-sentry-component="TpuTutorial" data-sentry-source-file="tutorial.tsx" />;
};